// extracted by mini-css-extract-plugin
module.exports =  {"form-row":"ComponentEditForm-module__form-row___hoNJv","label":"ComponentEditForm-module__label___dmCiw"};